export default __webpack_public_path__ + "static/media/paper.c6dd4303.svg";